import { Link } from "react-router-dom";
import { Calendar, ClipboardList, DollarSign, Settings, UserCheck, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/hooks/useAuth";
import { usePermissions } from "@/hooks/usePermissions";

const cards = [
  { to: "/calendario", label: "Calendário", desc: "Visualize e gerencie todos os turnos", icon: Calendar, color: "bg-brand-500" },
  { to: "/meus-turnos", label: "Meus Turnos", desc: "Veja seus turnos do mês", icon: ClipboardList, color: "bg-blue-500" },
  { to: "/remuneracao", label: "Remuneração", desc: "Acompanhe sua remuneração mensal", icon: DollarSign, color: "bg-emerald-600" },
  { to: "/profissionais", label: "Profissionais", desc: "Equipe de veterinários e auxiliares", icon: Users, color: "bg-purple-500" },
  { to: "/solicitacoes", label: "Solicitações", desc: "Pedidos de turnos pendentes", icon: UserCheck, color: "bg-amber-500" },
  { to: "/admin", label: "Administração", desc: "Configurações e usuários", icon: Settings, color: "bg-slate-700", admin: true },
  // 24/09: a coordenação de escala entra no mesmo /admin, que para ela mostra
  // só tipos de turno e calendário.
  { to: "/admin", label: "Tipos de turno e calendário", desc: "Tipos de turno, feriados e avisos", icon: Settings, color: "bg-slate-700", escala: true },
];

export function Dashboard() {
  const { user } = useAuth();
  const { isAdmin, isEscala } = usePermissions();
  const visible = cards.filter((c) => (c.admin ? isAdmin : c.escala ? isEscala : true));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Bem-vindo, {user?.name}!</h1>
        <p className="mt-1 text-slate-500">Gerencie seus turnos e acompanhe sua remuneração.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((c) => (
          <Link key={c.to} to={c.to}>
            <Card className="h-full transition-shadow hover:shadow-md">
              <CardContent className="flex items-center gap-4 p-6">
                <div className={`flex h-12 w-12 items-center justify-center rounded-lg ${c.color} text-white`}>
                  <c.icon className="h-6 w-6" />
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{c.label}</div>
                  <div className="text-sm text-slate-500">{c.desc}</div>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
